import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { HA_QUERY_INFO } from '@doda/common/src/constants/seo/occupationConstants';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { convertQueryToURI } from './convertQueryToURI';

/**
 * Creates a URL for the occupation page based on the provided query parameters.
 * @param queryParams - The query parameters used to generate the URL.
 * @param queryParams.ha - An array containing the 'ha' parameter values.
 * @returns The generated URL or undefined if 'ha' is not valid.
 */
export const createOccupationUrl = (queryParams: AppQueryParams) => {
  const { ha } = queryParams;
  if (!ha || !ha.length) return '';
  if (!Object.keys(HA_QUERY_INFO).includes(ha[0])) return '';

  return makeStaticUrl(
    convertQueryToURI(queryParams),
    DODA_SITE_URL.occupation
  );
};
